import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import Checkbox from "@faire/web--source/slate/Checkbox";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import privacyPath from "@faire/web-api--source/routes/www/privacy";
import tosPath from "@faire/web-api--source/routes/www/tos";
import tosBrandPath from "@faire/web-api--source/routes/www/tos-brand";
import React from "react";
import styled from "styled-components";
export var AcceptTermsCheckbox = function(param) {
    var hasError = param.hasError, value = param.value, onChange = param.onChange;
    return /*#__PURE__*/ _jsx(Row, {
        children: /*#__PURE__*/ _jsx(Checkbox, {
            "data-test-id": "accept-terms-checkbox",
            margin: "2px 8px 0 0",
            align: "flex-start",
            checked: value,
            borderColor: hasError ? Core.border.critical : undefined,
            onChange: onChange,
            children: /*#__PURE__*/ _jsx(Typography, {
                color: hasError ? Core.text.critical : Core.text.default,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "PsU1SU",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "By proceeding, you're agreeing to our "
                        },
                        {
                            type: 8,
                            value: "TosLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Terms of Service"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "BrandLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Brand Agreement"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and "
                        },
                        {
                            type: 8,
                            value: "PrivacyLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Privacy Policy"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: {
                        TosLinkFormatting: TosLinkFormatting,
                        BrandLinkFormatting: BrandLinkFormatting,
                        PrivacyLinkFormatting: PrivacyLinkFormatting
                    }
                })
            })
        })
    });
};
var StyledLink = styled(EmbeddedLink).attrs({
    target: "_blank"
}).withConfig({
    componentId: "sc-d4cdc617-0"
})([
    "color:inherit;text-decoration-color:inherit;"
]);
var TosLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(StyledLink, {
        linkTo: tosPath(),
        children: chunks
    });
};
var BrandLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(StyledLink, {
        linkTo: tosBrandPath(),
        children: chunks
    });
};
var PrivacyLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(StyledLink, {
        linkTo: privacyPath(),
        children: chunks
    });
};
